// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var LogOut = function LogOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logout-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.727 10.664a.934.934 0 0 0 0-1.324l-5-5.004a.937.937 0 0 0-1.324 1.324L16.8 9.06l-9.613.004A.935.935 0 0 0 6.25 10c0 .52.418.938.938.938H16.8l-3.399 3.398a.937.937 0 0 0 1.324 1.324zM6.563 3.125c.519 0 .937-.418.937-.937a.935.935 0 0 0-.937-.938H3.438A3.44 3.44 0 0 0 0 4.688v10.625a3.44 3.44 0 0 0 3.438 3.437h3.125c.519 0 .937-.418.937-.937a.935.935 0 0 0-.937-.938H3.438c-.864 0-1.563-.7-1.563-1.562V4.688c0-.864.7-1.563 1.563-1.563z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logout-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
